export const BASE_URL = `${process.env.REACT_APP_BASE_URL}/api/v1`;
//export const BASE_URL = `http://localhost:6161/api/v1`;
